import React from 'react';
import { View } from 'react-native';

import Text from '../../components/text/Text';
import { useThemedStyles } from '../../hooks/useThemedStyles';
import PrimaryButton from './PrimaryButton';

/**
 * ActionDock: pinned footer with the screen's one primary button. Pass it to
 * Screen's `dock` prop so it sits above the tab bar and the banner slot.
 * Props:
 * - hint: line above the button, e.g. "After this: Recalculate and top up pick",
 *   "Up next: Sunshine Hospital · Emergency Department", "Tick all 8 bags to continue"
 * - action: PrimaryButton props ({ label, onPress, disabled, loading, icon, tone })
 * - children: extra content between the hint and the button (e.g. a secondary button)
 * - style
 */
const ActionDock = ({ hint, action, children, style }) => {
	const styles = useThemedStyles(createStyles);

	return (
		<View style={[styles.dock, style]}>
			<View style={styles.inner}>
				{Boolean(hint) && <Text style={styles.hint}>{hint}</Text>}
				{children}
				{Boolean(action) && <PrimaryButton {...action} />}
			</View>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space, layout } }) => ({
	dock: {
		backgroundColor: colors.surface,
		borderTopWidth: 1,
		borderTopColor: colors.border,
		paddingTop: space.md,
		paddingBottom: space.lg,
		paddingHorizontal: space.gutter,
	},
	// Same column as the Screen body (max content width minus its 18 pt gutters),
	// so the button never runs wider than the content on tablets.
	inner: {
		width: '100%',
		maxWidth: layout.maxContentWidth - 2 * space.gutter,
		alignSelf: 'center',
		gap: 10,
	},
	hint: {
		...type.caption,
		color: colors.textSecondary,
	},
});

export default ActionDock;
